import React from 'react';
import { IconProps } from '../types/types';

const NFTB: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><path d="M15.818 18.636V20H4v-1.364h11.818Zm0-18.636v17.273H4V0h11.818Zm-1.364 1.364h-9.09v14.545h9.09V1.364Z" fill="url(#a)"/><defs><linearGradient id="a" x1="8.181" y1=".881" x2="16.287" y2="11.031" gradientUnits="userSpaceOnUse"><stop stopColor="#18D3FD"/><stop offset="1" stopColor="#DE04FF"/></linearGradient></defs></svg>
);

export default NFTB;
